import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormLicenseTemplate from './form-license-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateLicenseItemTemplate } from 'works/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateLicenseTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createLicenseItemTemplate.errors) {
      addErrorsToForm(form, response.createLicenseItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createLicense] = useMutation(CreateLicenseItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to create Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    createLicense({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <FormLicenseTemplate
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
      showExpiration
      form={form}
    />
  );
}

CreateLicenseTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
